

export const IndicatorSeparator = ({ innerProps }) => <span {...innerProps} />;
